import { Component, Host, h, Prop, Element } from '@stencil/core';
import { VdsContentBaseProperties } from './vds-content-base.interface';

@Component({
  tag: 'vds-content-base',
  styleUrl: 'vds-content-base.scss',
  shadow: true,
})
export class VdsContentBase implements VdsContentBaseProperties {

  @Element() el!: HTMLElement;

  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline = '';

  /**
   * Controls wether or not the downloads should be displayed
   */
  @Prop() showDownloads = false;

  render() {
    const { headline, subline, showDownloads } = this;

    return (
      <Host>
        <h2 class="font-heavy text-h2-mobile sm:text-h2-tablet lg:text-h2-desktop text-grey uppercase break-words" innerHTML={headline}></h2>
        <h3 class="font-regular text-s2-mobile sm:text-s2-tablet lg:text-s2-desktop text-berry uppercase mt-2 break-words" innerHTML={subline}></h3>
        <slot name="copy-above"></slot>
        <slot name="media"></slot>
        <slot name="copy-below"></slot>
        { showDownloads && (
            <slot name='downloads'></slot>
        )}
      </Host>
    );
  }

}
